import cmfApi from "../index";

const votesApi = (headers, params) =>
	cmfApi.get("/votes/count", { headers, params });

export default votesApi;
